/* Wishlist (snippets/wish-btn.liquid, sections/main-wishlist.liquid). Added 2026-10-22.
   Handles are kept in localStorage under ab_wishlist, so saved items stay on this device
   only. If storage is blocked the hearts still toggle for the page but nothing is kept. */
(function () {
  var KEY = 'ab_wishlist';
  function read() { try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
  function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 60))); } catch (e) {} }
  function sync() {
    var list = read();
    document.querySelectorAll('[data-wish]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-wish')) > -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.classList.toggle('is-on', on);
      var label = on ? b.getAttribute('data-label-remove') : b.getAttribute('data-label-add');
      if (label) { b.setAttribute('aria-label', label); var tx = b.querySelector('.wish-text'); if (tx) tx.textContent = label; }
    });
    document.querySelectorAll('[data-wish-count]').forEach(function (el) { el.textContent = list.length ? '(' + list.length + ')' : ''; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-wish]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var h = b.getAttribute('data-wish'), list = read(), i = list.indexOf(h);
    if (i > -1) list.splice(i, 1); else list.unshift(h);
    write(list); sync();
    if (b.hasAttribute('data-wish-remove')) render();
  });
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(c) { return 'LE ' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  // photo framing per product (templates/product.frame.liquid), same as the server built cards
  function frame(root, h) { return fetch(root + 'products/' + encodeURIComponent(h) + '?view=frame').then(function (r) { return r.ok ? r.json() : {}; }).catch(function () { return {}; }); }
  var grid = document.querySelector('[data-wish-grid]');
  var empty = document.querySelector('[data-wish-empty]');
  function render() {
    if (!grid) return;
    var list = read(), root = grid.getAttribute('data-root') || '/';
    if (!list.length) { grid.innerHTML = ''; if (empty) empty.hidden = false; return; }
    Promise.all(list.map(function (h) {
      return Promise.all([fetch(root + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }), frame(root, h)])
        .then(function (x) { if (x[0]) x[0]._frame = x[1].card || ''; return x[0]; });
    })).then(function (items) {
      items = items.filter(Boolean);
      if (!items.length) { grid.innerHTML = ''; if (empty) empty.hidden = false; return; }
      if (empty) empty.hidden = true;
      var add = grid.getAttribute('data-add'), opts = grid.getAttribute('data-options'), sold = grid.getAttribute('data-soldout'), rm = grid.getAttribute('data-remove');
      var action = grid.getAttribute('data-cart-add') || (root + 'cart/add');
      grid.innerHTML = items.map(function (p) {
        var url = root + 'products/' + esc(p.handle);
        var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=600' : '';
        var single = p.variants && p.variants.length === 1;
        var v = (p.variants || []).filter(function (x) { return x.available; })[0];
        var cta = !p.available ? '' : (single && v
          ? '<div class="card-atc"><form method="post" action="' + esc(action) + '"><input type="hidden" name="id" value="' + v.id + '"><input type="hidden" name="quantity" value="1"><button class="add-to-cart" type="submit">' + esc(add) + '</button></form></div>'
          : '<div class="card-atc"><a class="add-to-cart" href="' + url + '">' + esc(opts) + '</a></div>');
        return '<article class="product-card' + (p.available ? '' : ' is-soldout') + '">' +
          '<button type="button" class="wish-btn is-on" data-wish="' + esc(p.handle) + '" data-wish-remove aria-pressed="true" aria-label="' + esc(rm) + '"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-7-4.5-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 11c0 5.5-7 10-7 10z"/></svg></button>' +
          '<a href="' + url + '" class="product-img-area pimg-1" aria-label="' + esc(p.title) + '"' + (p._frame ? ' style="' + esc(p._frame) + '"' : '') + '>' + (img ? '<img class="product-svg ' + (p._frame ? 'has-frame' : 'no-zoom') + '" src="' + esc(img) + '" alt="" loading="lazy" width="600" height="450">' : '') +
          (p.available ? '' : '<span class="product-badge badge-stamp">' + esc(sold) + '</span>') + '</a>' +
          '<div class="product-body"><h3 class="product-name"><a href="' + url + '">' + esc(p.title) + '</a></h3>' +
          '<div class="product-price-row"><span class="product-price">' + money(p.price) + '</span></div>' + cta + '</div></article>';
      }).join('');
    });
  }
  sync();
  render();
})();
